<template>
    <Modal
        :class-name="'create-new-plan'"
        :title="form._id ? 'Plan Güncelle' : 'Plan Oluştur'"
        @cancel="cancelAction"
        :show-footer="false"
    >
        <div
            class="d-flex flex-column"
            style="overflow: scroll; height: 60vh; padding-right: 5px; padding-bottom: 15px"
        >
            <div v-if="form.type !== 'feature'">
                <div style="font-weight: bold">Settings</div>
                <a-checkbox v-model="form.isFreePlan">Ücretsiz Paket</a-checkbox>
                <a-checkbox v-if="!form.isFreePlan" v-model="form.isOnDemand">Anlık Ücret Alınacak </a-checkbox>
                <a-checkbox v-if="!form.isFreePlan" v-model="form.isTeamPlan">Takım Planı </a-checkbox>
                <a-checkbox v-if="!form.isFreePlan" v-model="form.isAppsumo">Appsumo Paketi</a-checkbox>
            </div>
            <div>
                <div style="font-weight: bold">Plan Sırası</div>
                <a-input class="plan-input" v-model="form.order" :min="0" type="number"></a-input>
            </div>
            <div v-if="form.isAppsumo">
                <div style="font-weight: bold">Gerekli Kod Sayısı</div>
                <a-input class="plan-input" v-model="form.requiredCodes" :min="0" type="number"></a-input>
            </div>
            <div>
                <div style="font-weight: bold">Başlık</div>
                <a-input class="plan-input" v-model="form.title" type="text"></a-input>
            </div>
            <div>
                <div style="font-weight: bold">Alt Başlık</div>
                <a-input class="plan-input" v-model="form.altTitle" type="text"></a-input>
            </div>
            <div>
                <div style="font-weight: bold">Paket Türü</div>
                <a-select v-model="form.type" style="width: 100%">
                    <a-select-option :value="'supsis'"> Supsis</a-select-option>
                    <a-select-option :value="'whatsapp'"> Whatsapp</a-select-option>
                    <a-select-option :value="'whatsapp-business'"> Whatsapp Business</a-select-option>
                    <a-select-option :value="'chatbot'"> Chatbot</a-select-option>
                    <a-select-option :value="'instagram'"> Instagram</a-select-option>
                    <a-select-option :value="'messenger'"> Messenger</a-select-option>
                    <a-select-option :value="'telegram'"> Telegram</a-select-option>
                    <a-select-option :value="'feature'"> Özellik</a-select-option>
                    <a-select-option :value="'custom'"> Custom</a-select-option>
                </a-select>
            </div>
            <div style="margin-top: 15px" v-if="form.type === 'custom' || form.type === 'feature'">
                <div style="font-weight: bold">
                    {{ form.type === "custom" ? "Custom Paket Key" : "Özellik Anahtarı" }}
                </div>
                <a-input class="plan-input" v-model="form.dynamicType" type="text" placeholder="whatsapp-broadcast" />
            </div>
            <div style="margin-top: 15px">
                <div style="font-weight: bold">Customer Key</div>
                <a-input class="plan-input" v-model="form.partnerKey" type="text" placeholder="appsumo" />
            </div>
            <div style="margin-top: 15px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">Aylık Fiyat</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.price" />
            </div>
            <div style="margin-top: 15px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">Aylık İndirimsiz Fiyat (İşlevsiz Göstermelik)</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.discountPrice" />
            </div>
            <div style="margin-top: 5px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">2 Yıllık İndirim</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.twoYearDiscount" />
            </div>
            <div style="margin-top: 5px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">Yıllık İndirim</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.yearlyDiscount" />
            </div>
            <div style="margin-top: 5px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">6 Aylık İndirim</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.sixMonthlyDiscount" />
            </div>
            <div style="margin-top: 5px" v-if="!form.isFreePlan">
                <div style="font-weight: bold">3 Aylık İndirim</div>
                <a-input class="plan-input" :min="0" type="number" v-model="form.threeMonthlyDiscount" />
            </div>
            <div style="margin-top: 5px">
                <div style="font-weight: bold">Features</div>
                <div style="width: 100%">
                    <a-select v-model="featuresForm" style="width: 100%" @select="onSelectFeaturesForm">
                        <a-select-option value="agent">Agent</a-select-option>
                        <a-select-option value="archive">Archive</a-select-option>
                        <a-select-option value="chat">Chat</a-select-option>
                        <a-select-option value="chatbot">Chatbot</a-select-option>
                        <a-select-option value="mail">Mail</a-select-option>
                        <a-select-option value="report">Report</a-select-option>
                        <a-select-option value="sms">SMS</a-select-option>
                        <a-select-option value="support">Support</a-select-option>
                        <a-select-option value="system">System</a-select-option>
                        <a-select-option value="team_chat">Team Chat</a-select-option>
                        <a-select-option value="triggers">Triggers</a-select-option>
                        <a-select-option value="whatsapp">Whatsapp</a-select-option>
                        <a-select-option value="instagram">Instagram</a-select-option>
                        <a-select-option value="messenger">Messenger</a-select-option>
                        <a-select-option value="services">Services</a-select-option>
                    </a-select>
                    <div style="margin-top: 10px">
                        <AgentFeature
                            v-if="features.includes('agent')"
                            v-model="form"
                            @close="deleteFeature('agent')"
                        />
                        <ArchiveFeature
                            v-if="features.includes('archive')"
                            v-model="form"
                            @close="deleteFeature('archive')"
                        />
                        <ChatFeature v-if="features.includes('chat')" v-model="form" @close="deleteFeature('chat')" />
                        <ChatBotFeature
                            v-if="features.includes('chatbot')"
                            v-model="form"
                            @close="deleteFeature('chatbot')"
                        />
                        <MailFeature v-if="features.includes('mail')" v-model="form" @close="deleteFeature('mail')" />
                        <ReportFeature
                            v-if="features.includes('report')"
                            v-model="form"
                            @close="deleteFeature('report')"
                        />
                        <SMSFeature v-if="features.includes('sms')" v-model="form" @close="deleteFeature('sms')" />
                        <SupportFeature
                            v-if="features.includes('support')"
                            v-model="form"
                            @close="deleteFeature('support')"
                        />
                        <SystemFeature
                            v-if="features.includes('system')"
                            v-model="form"
                            @close="deleteFeature('system')"
                        />
                        <TeamChatFeature
                            v-if="features.includes('team_chat')"
                            v-model="form"
                            @close="deleteFeature('team_chat')"
                        />
                        <TriggerFeature
                            v-if="features.includes('triggers')"
                            v-model="form"
                            @close="deleteFeature('triggers')"
                        />
                        <WhatsappFeature
                            v-if="features.includes('whatsapp')"
                            v-model="form"
                            @close="deleteFeature('whatsapp')"
                        />
                        <InstagramFeature
                            v-if="features.includes('instagram')"
                            v-model="form"
                            @close="deleteFeature('instagram')"
                        />
                        <MessengerFeature
                            v-if="features.includes('messenger')"
                            v-model="form"
                            @close="deleteFeature('messenger')"
                        />

                        <ServicesFeature
                            v-if="features.includes('services')"
                            v-model="form"
                            @close="deleteFeature('services')"
                        />
                    </div>
                </div>
            </div>
        </div>
        <b-button size="sm" variant="success" v-if="form._id" @click="updateAction" style="margin-top: 10px">
            {{ $t("message.update") }}
        </b-button>
        <b-button size="sm" variant="success" v-else @click="createAction" style="margin-top: 10px">
            {{ $t("message.save") }}
        </b-button>
        <b-button size="sm" variant="error" @click="cancelAction" style="margin-top: 2px"> İptal Et</b-button>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import _ from "lodash";
import { mapState } from "vuex";
import AgentFeature from "./feature-items/Agent";
import ArchiveFeature from "./feature-items/Archive";
import ChatFeature from "./feature-items/Chat";
import ChatBotFeature from "./feature-items/Chatbot";
import MailFeature from "./feature-items/Mail";
import ReportFeature from "./feature-items/Report";
import SMSFeature from "./feature-items/SMS";
import SupportFeature from "./feature-items/Support";
import SystemFeature from "./feature-items/System";
import TeamChatFeature from "./feature-items/TeamChat";
import TriggerFeature from "./feature-items/Triggers";
import WhatsappFeature from "./feature-items/Whatsapp";
import ServicesFeature from "./feature-items/Services.vue";
import InstagramFeature from "./feature-items/Instagram.vue";
import MessengerFeature from "./feature-items/Messenger.vue";

export default {
    name: "CreateNewPlanModal",
    components: {
        MessengerFeature,
        InstagramFeature,
        ServicesFeature,
        Modal,
        AgentFeature,
        ArchiveFeature,
        ChatFeature,
        ChatBotFeature,
        MailFeature,
        ReportFeature,
        SMSFeature,
        SupportFeature,
        SystemFeature,
        TeamChatFeature,
        TriggerFeature,
        WhatsappFeature,
    },
    props: {
        value: {
            type: Object,
        },
    },
    data: () => ({
        form: {},
        featuresPricingForm: null,
        featuresForm: null,
        features: [],
    }),
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            plans: (state) =>
                state.site.plans.reduce((a, b) => {
                    a[b.dynamicType || b.type] = b;
                    return a;
                }),
        }),
    },
    mounted() {
        this.form = _.cloneDeep(
            this.value || {
                type: "custom",
                title: null,
                altTitle: null,
                isPopular: false,
                price: 0,
                discountPrice: 0,
                twoYearDiscount: 0,
                yearlyDiscount: 0,
                sixMonthlyDiscount: 0,
                threeMonthlyDiscount: 0,
                dynamicType: null,
                partnerKey: null,
                features: [],
                isFreePlan: false,
                isOnDemand: false,
                isAppsumo: false,
                isTeamPlan: false,
                requiredCodes: 0,
            }
        );
        this.features = this.form.features.map((f) => f.type);
    },
    methods: {
        cancelAction() {
            this.$emit("cancel");
        },
        createAction() {
            this.$emit("input", this.form);
            this.$emit("create", this.form);
        },
        updateAction() {
            this.$emit("input", this.form);
            this.$emit("update", this.form);
        },
        onSelectFeaturesForm(val) {
            if (!this.features.includes(val)) this.features = [...this.features, val];
            this.featuresForm = null;
        },
        deleteFeature(key) {
            this.features = this.features.filter((f) => f !== key);
            this.form.features = Object.keys(this.form.features).filter((x) => x.type !== key);
        },
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                if (_.isEqual(newVal, oldVal)) {
                    if (newVal.isAppsumo) {
                        this.form.type = "custom";
                        this.form.partnerKey = "appsumo";
                        this.form.dynamicType = "appsumo";
                    }
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.create-new-plan {
    .ant-modal {
        width: 70vw !important;
    }
}

.plan-input {
    width: 100%;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
}
</style>
